import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {CountryStatesService, IState} from '../../country-states-service';

@Component({
    selector: 'app-state-select',
    templateUrl: './state-select.component.html',
    standalone: false
})
export class StateSelectComponent implements OnInit {
  @Input() controlName = 'state';
  _countryId = 1;
  @Input() controlLabel = 'State';
  @Input() cityControlName = 'city';
  @Input() formGroup: FormGroup;
  @Input() multiple = false;
  @Input() cities: string[];
  @Input() reloadCities: boolean;
  @Output() citiesChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() selectionChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() openedChange: EventEmitter<any> = new EventEmitter<any>();

  @Input() set countryId(value: number) {
    this._countryId = value;
    this.loadStates();
  }

  states: IState[];

  constructor(
    private countryStatesService: CountryStatesService,
  ) {
  }

  ngOnInit() {
    this.loadStates();
  }

  onSelectionChanged(event) {
    this.selectionChange.emit(event);
    if (this.reloadCities) {
      this.loadCities(event.value);
    }
  }

  onOpenedChanged(event) {
    this.openedChange.emit(event);
  }

  private loadStates() {
    this.countryStatesService.getSortedStatesWithCitiesForCountry(this._countryId).subscribe((states) => {
      this.states = states;

      if (this.reloadCities) {
        const stateIds = this.formGroup.controls[this.controlName].value;

        if (Array.isArray(stateIds)) {
          this.loadCities(stateIds);
        }
      }
    });
  }

  private loadCities(stateIds: number[]): void {
    const cities = this.getCities(this.states, stateIds);
    this.citiesChange.emit(cities);

    const formCities = this.formGroup.controls[this.cityControlName].value || [];
    const selectedCities = {};
    selectedCities[this.cityControlName] = formCities.filter(city => cities.includes(city) || city === -1);
    this.formGroup.patchValue(selectedCities);
    this.formGroup.updateValueAndValidity();
  }

  getCities(states: IState[], stateIds: number[]) {
    return states
      .filter(state => stateIds == null || (Array.isArray(stateIds) && stateIds.length === 0) || stateIds.includes(-1) || stateIds.includes(state.id))
      .map(state => state?.cities || [])
      .reduce((previousValue, currentValue) => {
        return previousValue.concat(currentValue);
      }, []).filter(city => city !== null).sort((a, b) => a > b ? 1 : -1);
  }

}
